"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioDropdown = void 0;
var api_wrapper_1 = require("@src/api/api-wrapper");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var object_service_1 = require("@src/services/object-service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var StudioDropdown = /** @class */ (function () {
    function StudioDropdown() {
    }
    StudioDropdown.prototype.getStudios = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var apiWrapper, hiddenStudios, filteredStudios, hiddenStudiosByTag, allStudios, yondStudioToContractMapping_1, contracts;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
                        hiddenStudios = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hideStudioIds;
                        filteredStudios = (_d = (_c = config.get) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.filterStudioIds;
                        hiddenStudiosByTag = (_f = (_e = config.get) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.hideStudiosByTags;
                        return [4 /*yield*/, apiWrapper.getStudios()];
                    case 1:
                        allStudios = _j.sent();
                        if (!(config.get.technologyType === 'yond')) return [3 /*break*/, 3];
                        localStorage.removeItem(input_mapping_const_1._AllMappings.studioId.uid); // get all studios for yond
                        yondStudioToContractMapping_1 = (_h = (_g = config.get) === null || _g === void 0 ? void 0 : _g.yond) === null || _h === void 0 ? void 0 : _h.studioLocationMapping;
                        if (!yondStudioToContractMapping_1) {
                            console.warn('Yond trial booking needs a studio location mapping');
                            this.studios = [];
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, apiWrapper.getOfferings('')];
                    case 2:
                        contracts = _j.sent();
                        this.trialBookingContracts = contracts.filter(function (cont) { return cont.terms.filter(function (term) { return term.termUnit === 'DAY' && term.termValue === 1; }).length > 0; });
                        console.log('Got trial booking contracts', this.trialBookingContracts);
                        allStudios = allStudios.filter(function (studio) {
                            return _this.trialBookingContracts.find(function (contract) { var _a; return (_a = yondStudioToContractMapping_1[studio.id]) === null || _a === void 0 ? void 0 : _a.includes(contract.yondTerifOid || 'none'); }) !== undefined;
                        });
                        console.log('Remaining yond studios with a trial contract', allStudios);
                        _j.label = 3;
                    case 3:
                        if (Array.isArray(hiddenStudios) && hiddenStudios.length > 0) {
                            allStudios = allStudios.filter(function (s) { return !hiddenStudios.includes(s.id); });
                            console.log('filtering studios: ', allStudios);
                        }
                        if (Array.isArray(filteredStudios) && filteredStudios.length > 0) {
                            allStudios = allStudios.filter(function (s) { return filteredStudios.includes(s.id); });
                            console.log('filtering studios: ', allStudios);
                        }
                        if (Array.isArray(hiddenStudiosByTag) && hiddenStudiosByTag.length > 0) {
                            allStudios = allStudios.filter(function (s) {
                                var tags = (Array.isArray(s.studioTags) ? s.studioTags : [s.studioTags]).map(function (tag) {
                                    return typeof tag === 'string' ? tag : tag.name;
                                });
                                return !tags.some(function (tag) { return hiddenStudiosByTag.includes(tag); });
                            });
                            console.log('filtering studios: ', allStudios);
                        }
                        this.studios = allStudios;
                        return [2 /*return*/];
                }
            });
        });
    };
    StudioDropdown.prototype.generateStudioOptions = function (searchString) {
        var options = [];
        this.studios.forEach(function (studio) {
            var _a;
            if ((searchString && studio.studioName.toLowerCase().includes(searchString.toLowerCase())) || !searchString) {
                options.push((0, cash_dom_1.default)("<option data-type=\"studio\" value=\"".concat((_a = studio.yondStudioOid) !== null && _a !== void 0 ? _a : studio.id, "\">").concat(studio.studioName, "</option>")));
            }
        });
        return options;
    };
    StudioDropdown.prototype.updateDropdown = function (dropdown, searchString) {
        var options = this.generateStudioOptions(searchString);
        dropdown.find('option[data-type="studio"]').remove();
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            dropdown.append(option);
        }
    };
    StudioDropdown.prototype.getYondTrialBookingData = function (config, customer, selectedDay) {
        var _a, _b, _c, _d;
        var yondStudioToContractMapping = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.yond) === null || _b === void 0 ? void 0 : _b.studioLocationMapping;
        if (!yondStudioToContractMapping) {
            console.warn('Yond trial booking needs a studio location mapping');
            return;
        }
        var selectedStudioId = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid);
        var selectedStudio = this.studios.find(function (s) { return s.yondStudioOid === selectedStudioId; });
        var possibleContractIds = yondStudioToContractMapping[selectedStudio.id];
        var selectedOffering = (_c = this.trialBookingContracts.filter(function (cont) {
            return possibleContractIds.includes(cont.yondTerifOid) &&
                cont.terms.filter(function (term) { return term.termUnit === 'DAY' && term.termValue === 1; }).length > 0;
        })) === null || _c === void 0 ? void 0 : _c[0];
        console.log('selected studio id', selectedStudioId, 'selected studio', selectedStudio, 'possible contracts', possibleContractIds, 'selectedOffering', selectedOffering);
        return {
            home_facility_oid: selectedStudio.yondStudioOid,
            legalEntityOid: selectedStudio.yondLegalEntitiyOid,
            person: {
                name: { first_name: customer.firstname, last_name: customer.lastname },
                addresses: [],
                phones: [{ number: customer.telephone_mobile, country_oid: '49' }],
                emails: [{ address: customer.email }],
            },
            tariff_variant_oid: (_d = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.id) === null || _d === void 0 ? void 0 : _d.toString(),
            selectedTerm: '1 DAY',
            givenConsents: [],
            contractStartDate: selectedDay,
        };
    };
    return StudioDropdown;
}());
exports.StudioDropdown = StudioDropdown;
